/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShipList } from './ShipList';
import {
    ShipListFromJSON,
    ShipListFromJSONTyped,
    ShipListToJSON,
} from './ShipList';

/**
 * 
 * @export
 * @interface GetShiplists200Response
 */
export interface GetShiplists200Response {
    /**
     * 
     * @type {Array<ShipList>}
     * @memberof GetShiplists200Response
     */
    records?: Array<ShipList>;
}

/**
 * Check if a given object implements the GetShiplists200Response interface.
 */
export function instanceOfGetShiplists200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetShiplists200ResponseFromJSON(json: any): GetShiplists200Response {
    return GetShiplists200ResponseFromJSONTyped(json, false);
}

export function GetShiplists200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetShiplists200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ShipListFromJSON)),
    };
}

export function GetShiplists200ResponseToJSON(value?: GetShiplists200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ShipListToJSON)),
    };
}

